import { useState, type MouseEvent } from 'react';

const STORAGE_KEY = 'baoliao-reminders';

const readReminders = (): string[] => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export default function ReminderButton({
  sessionId,
  variant = 'outline',
}: {
  sessionId: string;
  variant?: 'outline' | 'solid';
}) {
  const [reminded, setReminded] = useState<boolean>(() => readReminders().includes(sessionId));

  const toggle = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    const current = readReminders();
    const next = current.includes(sessionId)
      ? current.filter((id) => id !== sessionId)
      : [...current, sessionId];
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    setReminded(next.includes(sessionId));
  };

  const base = 'flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors';
  const style = reminded
    ? 'border border-secondary-300 bg-secondary-100 text-secondary-900'
    : variant === 'solid'
      ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
      : 'border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700';

  return (
    <button type="button" onClick={toggle} className={`${base} ${style}`} aria-pressed={reminded}>
      <span className="w-3.5 h-3.5 flex items-center justify-center">
        <i className={reminded ? 'ri-notification-off-line' : 'ri-notification-3-line'} aria-hidden="true" />
      </span>
      {reminded ? '已设提醒' : '设提醒'}
    </button>
  );
}